import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Tooltip } from "@mui/material";
import { useGetAdminNotificationListMutation } from "../../service/notifications";
import { CommonBody, Notifications } from "../../types/General";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { errorToast, getFromStorage } from "../../helpers";
import TableComponent from "../../components/TableComponent";
import { isValidInput } from "../../utils/validations";
import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { setUnreadNotificationCount } from "../../reducers/generalSlice";
import { useAppDispatch } from "../../hooks/store";
import { useLazyGetProfileQuery } from "../../service/auth";
import { STORAGE_KEYS } from "../../constants/storageKeys";

const RecievedNotifications = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [rows, setRows] = useState<Notifications[]>([]);
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const [openWarnModal, setOpenWarnModal] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [getUser] = useLazyGetProfileQuery();

  const token = getFromStorage(STORAGE_KEYS.token);

  const [getNotifications] = useGetAdminNotificationListMutation();
  const [count, setCount] = useState(0);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const fetchNotifications = async () => {
    const body = {
      start: page,
      length: 10,
      search: debouncedSearchTerm.trim(),
    };
    setLoading(true);
    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await getNotifications(encryptedBody).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
        if (token) {
          getUserDetails();
        }
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [page, debouncedSearchTerm]);

  useEffect(() => {
    dispatch(setUnreadNotificationCount(0));
  }, []);

  const handleDelete = async () => {
    return;
    //  setLoading(true);
    //  try {
    //    const response = await deleteNotification({ id: selectedId }).unwrap();
    //    setLoading(false);

    //    if (response?.status === 200) {
    //      successToast("Notification deleted successfully");
    //      fetchNotifications();
    //    }
    //  } catch (error: any) {
    //    errorToast(error?.data?.message || "");
    //    setLoading(false);
    //  }
  };
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 200,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.title || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "message",
      headerName: "Message",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const message = row?.message ?? "";
        const truncatedMessage =
          message.length >= 40 ? `${message.slice(0, 40)}...` : message;
        return (
          <div className="user_block">
            <p>
              <Tooltip title={<span>{message}</span>}>
                <span>{truncatedMessage}</span>
              </Tooltip>
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.6,
      minWidth: 150,
      field: "date",
      headerName: "Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.created_at).format("DD MMM YYYY") || "-"}</p>
          </div>
        );
      },
    },

    // {
    //   flex: 0.5,
    //   minWidth: 140,
    //   field: "action",
    //   headerName: "action",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <div className="table_actions v2">
    //         <TableCell>
    //           <Box>
    //             <IconButton onClick={() => setOpenWarnModal(true)}>
    //               <img src="/static/images/trash_icon.svg" alt="Icon" />
    //             </IconButton>
    //           </Box>
    //         </TableCell>
    //       </div>
    //     );
    //   },
    // },
  ];

  const getUserDetails = async () => {
    const token = await getFromStorage(STORAGE_KEYS.token);

    if (token) {
      try {
        const result = await getUser().unwrap();
        if (result?.status === 200 && token) {
          if (typeof result?.data?.unread_notification === "number") {
            dispatch(
              setUnreadNotificationCount(result?.data?.unread_notification)
            );
          }
        }
      } catch (error) {
        errorToast(error?.data?.message || "");
      }
    }
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Recieved Notifications</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Recieved Notifications
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search..."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </div>
        </div>

        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={rows}
            count={count}
            page={page}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div>

        <ConfirmationModal
          text={"Are you sure to delete this notification?"}
          openModal={openWarnModal}
          setOpenModal={setOpenWarnModal}
          handleSubmit={handleDelete}
        />
      </div>
    </MainContainer>
  );
};

export default RecievedNotifications;
